import { render, staticRenderFns } from "./profitsuccess.vue?vue&type=template&id=bbc33958&"
import script from "./profitsuccess.vue?vue&type=script&lang=js&"
export * from "./profitsuccess.vue?vue&type=script&lang=js&"
import style0 from "./profitsuccess.vue?vue&type=style&index=0&id=bbc33958&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports